import type {
  FetchStaffBusinessOverviewDayArgs,
  FetchStaffBusinessOverviewTrainersArgs,
  FetchTrainerDisconnectedClientsArgs,
  ApiStaffBusinessOverviewDay,
  ApiStaffBusinessOverviewTrainer,
  ApiTrainerDisconnectedClient,
} from './types/staffBusinessOverview.types';

import { get } from './axios';

export const fetchStaffBusinessOverviewDay = ({
  date,
  organizationId,
}: FetchStaffBusinessOverviewDayArgs) => {
  return get<ApiStaffBusinessOverviewDay>(
    `/v2/organizations/${organizationId}/staff-business-overview/day`,
    { query: { date } },
  );
};

export const fetchStaffBusinessOverviewTrainers = async ({
  date,
  organizationId,
}: FetchStaffBusinessOverviewTrainersArgs) => {
  const response = await get<{ data: ApiStaffBusinessOverviewTrainer[] }>(
    `/v2/organizations/${organizationId}/staff-business-overview/trainers`,
    { query: { date } },
  );
  return response?.data ?? [];
};

export const fetchTrainerDisconnectedClients = async ({
  organizationId,
  trainerId,
}: FetchTrainerDisconnectedClientsArgs) => {
  const response = await get<{ data: ApiTrainerDisconnectedClient[] }>(
    `/v2/organizations/${organizationId}/staff-business-overview/trainers/${trainerId}/disconnected-clients`,
  );
  return response?.data ?? [];
};
